const OfsTradeMapper = (response) => {
    if (response) {
        return {
            message: response.data.status,
            orderID: response.data.nestOrderNumber,
            success: true,
        };
    }
    return {};
};
export default OfsTradeMapper;
